const locale = {
	APPLICATIONS: 'BG',
	HOME: 'Начало',
	CLEAN: 'Почистване',
	CLEANING_SESSIONS: 'История на почиствания',
    ROOMIE_AI: 'RoomieAI',
    ROOMS_ASSIGNMENT: 'Управление на задачи',
	MAINTENANCE: 'Техническа поддръжка',
	HELP_CENTER: 'Помощен Център',
	FAQ: 'ЧЗВ',
	GUIDES: 'Ръководство',
	SUPPORT: 'Поддръжка',
	SIGN_IN: 'Вход',
	LOADING: 'Зареждане',
	SETTINGS: 'Настройки',
};

export default locale;
